/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { Control, UseFormClearErrors } from "react-hook-form";
import ToggleButton from "../../../components/ToggleButton";
import FileUploader from "../../../components/common/FileUploader";
import {
  useFetchCountriesAllData,
  useFetchCountryCitiesAllData,
  useFetchCountryWarehouseAllData,
} from "../../../apis/locationApis";
import NewSelectInput from "../../../components/NewSelectInput";
import NewinputField from "../../../components/NewInput";
import CoverageCities from "./CoverageCities";
import { useLanguage } from "../../../context/LanguageContext";

type Props = {
  onClose: () => void;
  handleSubmit: () => void;
  // selectedWarehouse: string;
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>; // ✅ Add this
  coverageCityError: any;
  setCoverageCityError: any;
  isPending?: boolean;
  editable?: boolean;
  isEdit?: boolean;
  tireItem?: any;
  setTireItem?: any;
};

export default function AddTireModal({
  handleSubmit,
  register,
  errors,
  setValue,
  watch,
  clearErrors,
  coverageCityError,
  setCoverageCityError,
  isPending,
  editable,
  tireItem, // <-- use this
}: Props) {
  // const { data: warehouseData } = useFetchCountryWarehouseAllData();
  const { data: countriesData } = useFetchCountriesAllData();
  const { data: citiesData } = useFetchCountryCitiesAllData(
    watch("countryId"),
    undefined,
    "short"
  );
  const { t } = useLanguage();

  const [selectedCitiesArray, setSelectedCitiesArray] = useState<any>(
    tireItem?.coverageCity || [] // pre-fill if edit mode
  );
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    if (selectedCitiesArray) {
      setValue("coverageCity", selectedCitiesArray);
    }
  }, [selectedCitiesArray, setValue]);

  useEffect(() => {
    if (editable && tireItem) {
      // Pre-fill city selection if editing
      setSelectedCitiesArray(tireItem.coverageCity || []);
      setValue("coverageCity", tireItem.coverageCity || []);
    }
  }, [editable, tireItem, setValue]);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <NewinputField
          name="name"
          type="text"
          title={t("Tier Name")}
          placeholder={t("Enter Tier Name")}
          register={register}
          error={errors.name}
          validation={{
            required: t("Tier Name is required"),
            pattern: {
              value: /^(?=.*[A-Za-z])[A-Za-z0-9\s-]+$/,
              message:
                t("Tier Name must include at least one letter (not only numbers)"),
            },
            validate: (value) => {
              if (!value?.trim())
                return t("Tier Name cannot be empty or only spaces");
              return true;
            },
          }}
        />

        <NewSelectInput
          label={t("Select country")}
          selectOptions={
            countriesData?.map((country: any) => ({
              id: country?.id,
              value: country?.id,
              text: country?.name,
            })) || []
          }
          name="countryId"
          clearErrors={clearErrors}
          validation={{ required: t("Country is required") }}
          register={register}
          disabled={!countriesData || countriesData.length === 0}
          value={watch("countryId")}
          setValue={(val: string) => {
            setValue("countryId", val);
          }}
          error={errors.countryId}
        />
      </div>

      {!editable && (
        <div className="flex justify-between items-center">
          <h2 className="text-[#000000]/70 text-base">{t("Choose Bulk Upload")}</h2>
          <div className="flex items-center gap-1">
            <ToggleButton
              onChange={() => setChecked(!checked)}
              checked={checked}
            />
            <h2 className="text-[#000000]/70 text-base">{t("Bulk Upload")}</h2>
          </div>
        </div>
      )}

      {checked && !editable ? (
        <>
          <FileUploader
            name="document"
            classNameMain="bg-white outline-2 outline-dashed outline-[#212121]/10"
            title={t("Upload Your File")}
            message={t("Accepted formats: .xls, .xlsx, .csv | Max: 5MB")}
            placeHolder=""
            img="/img/upload-img.png"
            classNameImgDiv=" flex flex-col items-center justify-center"
          />
          <ul className="list-disc px-6 text-[#1E293B] text-sm">
            <li>{t("Download the Excel/CSV template before uploading.")} </li>
            <li>{t("Do not change column headers.")}</li>
          </ul>
          <div className="bg-[#ffffff] flex justify-between items-center px-4 py-2 rounded col-span-2">
            <p className="text-xs w-full">
              <b className="text-[#EC221F]">{t("Note")}</b>: {t("Please upload the file in the same format as the downloaded file")}
            </p>
            <div className="w-full flex justify-end items-end">
              <button className="bg-[#000000] text-white px-4 py-2 rounded flex items-center gap-1 text-xs">
                <img src="/img/csvxl.svg" alt="" /> {t("Download")}
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-2">
            <CoverageCities
              ALL_CITIES={citiesData}
              selectedCityData={selectedCitiesArray || []}
              setSelectedCitiesArray={setSelectedCitiesArray}
              error={coverageCityError}
              setError={setCoverageCityError}
              isEdit={!!editable}
            />
          </div>
        </div>
      )}

      <button
        onClick={() => handleSubmit()}
        className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium"
      >
        {isPending && (
          <svg
            className="animate-spin h-5 w-5 text-[#000000] mr-2"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
            />
          </svg>
        )}
        {editable ? t("Update") : t("Create")}
      </button>
    </div>
  );
}
